// Angular
import { Injectable } from '@angular/core';
// RxJS
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// Services
// State
import { AppState } from '../../reducers';
// Actions
import {
  ClearAllergyErrors,
  AllergyActionToggleLoading,
  AllergyActionTypes,
  AllergyCreated,
  AllergyOnServerCreated,
  AllergyOnServerDeleted,
  AllergyOnServerUpdated,
  AllergyPageLoaded,
  AllergyPageRequested,
  AllergyPageToggleLoading,
  AllergyUpdated,
  ThrowAllergyError,
  AllergyDeleted,
} from '../_actions/allergy.actions';
import { AllergiesService } from '../_services/allergy.service';

@Injectable()
export class AllergiesEffects {
  showPageLoadingDistpatcher = new AllergyPageToggleLoading({ isLoading: true });
  hideLoadingDistpatcher = new AllergyPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new AllergyActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new AllergyActionToggleLoading({ isLoading: false });

  @Effect()
  loadAllergiesPage$ = this.actions$.pipe(
    ofType<AllergyPageRequested>(AllergyActionTypes.AllergyPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.allergiesService.findAllergies(payload.entityId).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.errors) {
            this.store.dispatch(new ThrowAllergyError({ error: res }));
          } else {
            this.store.dispatch(new ClearAllergyErrors());
            this.store.dispatch(this.hideLoadingDistpatcher);
            const olives = [];
            this.store.dispatch(new ClearAllergyErrors());
            for (let i = 0; res.entry.length > i; i++) {
              olives.push(res.entry[i].resource);
            }
            return new AllergyPageLoaded({
              allergies: olives,
              totalCount: res.total,
            });
          }
        }),
      );
    }),
  );
  @Effect()
  updateAllergy$ = this.actions$.pipe(
    ofType<AllergyOnServerUpdated>(AllergyActionTypes.AllergyOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.allergiesService.updateAllergy(payload.allergy, payload.entityId).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res: any) => {
          if (res && res.errors) {
            return new ThrowAllergyError({ error: res });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(new ClearAllergyErrors());
            return new AllergyUpdated({
              allergy: {
                id: payload.allergy.id,
                changes: payload.allergy,
              },
            });
          }
        }),
      );
    }),
  );

  @Effect()
  createAllergy$ = this.actions$.pipe(
    ofType<AllergyOnServerCreated>(AllergyActionTypes.AllergyOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.allergiesService.createAllergy(payload.allergy, payload.entityId).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res && res.errors) {
            return new ThrowAllergyError({ error: res });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(new ClearAllergyErrors());
            return new AllergyCreated({ allergy: payload.allergy });
          }
        }),
      );
    }),
  );

  @Effect()
  deleteAllergy$ = this.actions$.pipe(
    ofType<AllergyOnServerDeleted>(AllergyActionTypes.AllergyOnServerDeleted),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.allergiesService.deleteAllergy(payload.allergy_id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map(() => {
          this.store.dispatch(this.hideActionLoadingDistpatcher);
          return new AllergyDeleted({ allergy_id: payload.allergy_id });
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private allergiesService: AllergiesService,
    private store: Store<AppState>,
  ) {}
}
